import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-logged-payment-card',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './logged-payment-card.component.html',
  styleUrls: ['./logged-payment-card.component.scss'],
})
export class LoggedPaymentCardComponent {
}
